import searchPage from './searchPage'
import searchModule from './searchModule'

export default () => {
	searchPage()
	searchModule()
}